module.exports = __webpack_public_path__ + "img/内页banner.af25b474.png";